<template>
    <div class="gallery-wrapper">
        <!-- Multiple preview groups -->
        <div class="group-preview" v-for="(group, i) in groups" :key="i" @click="openLightbox(i, 0)">
            <div class="preview-container">
                <img :src="group.cover" class="preview-image" />
                <div class="overlay">
                    <span class="overlay-text fontColor1 montserrat-600">{{ group.title }}</span>
                </div>
            </div>
        </div>
  
        <!-- Lightbox modal -->
        <div v-if="visible" class="lightbox-overlay" @click.self="visible = false">
            <div class="lightbox-content">
                <!-- Close button -->
                <button class="close-btn" @click="visible = false">×</button>

                <!-- Main image -->
                <img :src="currentImage" class="main-image" />

                <!-- Thumbnail strip -->
                <div class="thumbnails">
                    <img
                        v-for="(img, i) in currentGroup.gallery"
                        :key="i"
                        :src="img"
                        :class="['thumb', { active: i === currentIndex }]"
                        @click="currentIndex = i"
                    />
                </div>

                <!-- Navigation arrows -->
                <button v-if="hasPrev" class="nav left" @click="prev">‹</button>
                <button v-if="hasNext" class="nav right" @click="next">›</button>
            </div>
        </div>
    </div>
  </template>
  
  <script>

  const news2025july09Images = Array.from({ length: 9 }, (_, i) =>  require(`@/assets/images/news/news-2025/9-july/news-2025-${i + 1}.jpg`))
  const news2025june29Images = Array.from({ length: 10 }, (_, i) =>  require(`@/assets/images/news/news-2025/29-june/news-2025-${i + 1}.jpg`))
  const news2025june25Images = Array.from({ length: 10 }, (_, i) =>  require(`@/assets/images/news/news-2025/25-june/news-2025-${i + 1}.jpg`))
  const news2025june24Images = Array.from({ length: 4 }, (_, i) =>  require(`@/assets/images/news/news-2025/24-june/news-2025-${i + 1}.jpg`))
  const news2025june16Images = Array.from({ length: 9 }, (_, i) =>  require(`@/assets/images/news/news-2025/16-june/news-2025-${i + 1}.jpg`))
  const news8Images = Array.from({ length: 7 }, (_, i) =>  require(`@/assets/images/news/news-8/news-8-${i + 1}.jpg`))
  const news4Images = Array.from({ length: 39 }, (_, i) =>  require(`@/assets/images/news/news-4/news-4-${i + 1}.jpg`))
  const news11Images = Array.from({ length: 14 }, (_, i) =>  require(`@/assets/images/news/news-11/news-11-${i + 1}.jpg`))
  const news12Images = Array.from({ length: 12 }, (_, i) =>  require(`@/assets/images/news/news-12/news-12-${i + 1}.jpg`))
  const news14Images = Array.from({ length: 4 }, (_, i) =>  require(`@/assets/images/news/news-14/news-14-${i + 1}.jpg`))
  const gallery1Images = Array.from({ length: 4 }, (_, i) =>  require(`@/assets/images/gallery/2015-04-08/20150408_${i + 1}.jpg`))
  const gallery2Images = Array.from({ length: 2 }, (_, i) =>  require(`@/assets/images/gallery/2015-03-07/20150307_${i + 1}.jpg`))
  const gallery3Images = Array.from({ length: 6 }, (_, i) =>  require(`@/assets/images/gallery/2014-12-10/20141210_${i + 1}.jpg`))
  const gallery4Images = Array.from({ length: 4 }, (_, i) =>  require(`@/assets/images/gallery/2014-09-07/20140907_${i + 1}.jpg`))
  const gallery5Images = Array.from({ length: 7 }, (_, i) =>  require(`@/assets/images/gallery/2014-08-23_26/20140823_26_${i + 1}.jpg`))
  const gallery6Images = Array.from({ length: 4 }, (_, i) =>  require(`@/assets/images/gallery/2014-07-16_19/20140716_${i + 1}.jpg`))
  const gallery7Images = Array.from({ length: 4 }, (_, i) =>  require(`@/assets/images/gallery/2014-04-21_27/20140421_${i + 1}.jpg`))
  const gallery8Images = Array.from({ length: 4 }, (_, i) =>  require(`@/assets/images/gallery/2013-09-22/20130922_${i + 1}.jpg`))
  const gallery9Images = Array.from({ length: 4 }, (_, i) =>  require(`@/assets/images/gallery/2013-03-09/20130309_${i + 1}.jpg`))
  const gallery10Images = Array.from({ length: 3 }, (_, i) =>  require(`@/assets/images/gallery/2012-12-27/20121227_${i + 1}.jpg`))
  const gallery11Images = Array.from({ length: 7 }, (_, i) =>  require(`@/assets/images/gallery/2012-07-07/20120707_${i + 1}.jpg`))
  const gallery12Images = Array.from({ length: 7 }, (_, i) =>  require(`@/assets/images/gallery/2012-03-19/20120319_${i + 1}.jpg`))
  const gallery13Images = Array.from({ length: 6 }, (_, i) =>  require(`@/assets/images/gallery/2011-09-10_25/20110910_${i + 1}.jpg`))
  const gallery14Images = Array.from({ length: 8 }, (_, i) =>  require(`@/assets/images/gallery/2011-05-15/20110515_${i + 1}.jpg`))
  const gallery15Images = Array.from({ length: 8 }, (_, i) =>  require(`@/assets/images/gallery/2011-02-27/20110227_${i + 1}.jpg`))
  const gallery16Images = Array.from({ length: 7 }, (_, i) =>  require(`@/assets/images/gallery/2009-10-23_11/20091023_${i + 1}.jpg`))

  export default {
    data() {
      return {
        visible: false,
        currentGroupIndex: 0,
        currentIndex: 0,
        
        groups: [
            {   
                title: 'MMCOA (1987) Deputy President and Committee Member 09-july-2025',
                cover: require('@/assets/images/news/news-2025/9-july/news-2025-1.jpg'),
                gallery: news2025july09Images
            },
            {   
                title: 'Malaysia Heavy Construction Equipment Owners Association (MHCEOA) 29-june-2025',
                cover: require('@/assets/images/news/news-2025/29-june/news-2025-1.jpg'),
                gallery: news2025june29Images
            },
            {   
                title: 'Secretary General Goh Lian Chin representing MMCOA 25-june-2025',
                cover: require('@/assets/images/news/news-2025/25-june/news-2025-10.jpg'),
                gallery: news2025june25Images
            },
            {   
                title: '38th Anniversary Appreciation Banquet 16-june-2025',
                cover: require('@/assets/images/news/news-2025/24-june/news-2025-4.jpg'),
                gallery: news2025june24Images
            },
            {   
                title: '38th Anniversary Appreciation Banquet 16-june-2025',
                cover: require('@/assets/images/news/news-2025/16-june/news-2025-9.jpg'),
                gallery: news2025june16Images
            },
            {   
                title: 'Malaysia International Construction & Infrastructure Technology Exhibition 29th ~ 31st October 2019',
                cover: require('@/assets/images/news/news-8/news-8-3.jpg'),
                gallery: news8Images
            },
            {   
                title: 'Seminar: Enhance Safety Awareness Of Crane Operation 24 August 2019',
                cover: require('@/assets/images/news/news-4/news-4-30.jpg'),
                gallery: news4Images
            },
            {
                title: '中秋晚会暨2017年度会员子女教育奖励金颁发典礼- 13 Oct 2018',
                cover: require('@/assets/images/news/news-11/news-11-12.jpg'),
                gallery: news11Images
            },
            {
                title: 'Meeting With MBAM on 12 Oct 2018',
                cover: require('@/assets/images/news/news-12/news-12-1.jpg'),
                gallery: news12Images
            },
            {
                title: 'Meeting with CIDB',
                cover: require('@/assets/images/news/news-13.jpg'),
                gallery: [
                    require('@/assets/images/news/news-13.jpg'),
                ]
            },
            {
                title: 'MPC Teh Tarik session on Productivity Improvement Programme Through ezBusiness Excellence',
                cover: require('@/assets/images/news/news-14/news-14-3.jpg'),
                gallery: news14Images
            },
            {
                title: 'MMCOA MMC GAMUDA KVMRT Dialogue (2015.04.08)',
                cover: require('@/assets/images/gallery/2015-04-08/20150408_1.jpg'),
                gallery: gallery1Images
            },
            {
                title: 'MMCOA Johor Chinese New Year Dinner (2015.03.07)',
                cover: require('@/assets/images/gallery/2015-03-07/20150307_1.jpg'),
                gallery: gallery2Images
            },
            {
                title: 'MMCOA JPJ Putrajaya Meeting (2014.12.10)',
                cover: require('@/assets/images/gallery/2014-12-10/20141210_6.jpg'),
                gallery: gallery3Images
            },
            {
                title: 'MMCOA The Moon Festival Party (2014.09.07)',
                cover: require('@/assets/images/news/news-1.jpg'),
                cover: require('@/assets/images/gallery/2014-09-07/20140907_3.jpg'),
                gallery: gallery4Images
            },
            {
                title: 'MMCOA Taiwan Tourism Delegation (2014.08.23~26)',
                cover: require('@/assets/images/news/news-1.jpg'),
                cover: require('@/assets/images/gallery/2014-08-23_26/20140823_26_6.jpg'),
                gallery: gallery5Images
            },
            {
                title: 'MMCOA – “ONEBUILD” Malaysia Internatinal Exhibition (2014.07.16~19)',
                cover: require('@/assets/images/gallery/2014-07-16_19/20140716_4.jpg'),
                gallery: gallery6Images
            },
            {
                title: 'MMCOA Japan Tourism Delegation (2014.04.21~27)',
                cover: require('@/assets/images/gallery/2014-04-21_27/20140421_2.jpg'),
                gallery: gallery7Images
            },
            {
                title: 'MMCOA The Moon Festival Party (2013.09.22)',
                cover: require('@/assets/images/gallery/2013-09-22/20130922_2.jpg'),
                gallery: gallery8Images
            },
            {
                title: 'MMCOA Johor Chinese New Year Dinner (2013.03.09)',
                cover: require('@/assets/images/gallery/2013-03-09/20130309_1.jpg'),
                gallery: gallery9Images
            },
            {
                title: 'MMCOA Taiwan Crane Member Visit (2012.12.27)',
                cover: require('@/assets/images/gallery/2012-12-27/20121227_2.jpg'),
                gallery: gallery10Images
            },
            {
                title: 'MMCOA Raising Funds To Purchase A New Club Dinner (2012.07.07)',
                cover: require('@/assets/images/gallery/2012-07-07/20120707_7.jpg'),
                gallery: gallery11Images
            },
            {
                title: 'MMCOA Visit to Singapore Liebherr (2012.03.19)',
                cover: require('@/assets/images/gallery/2012-03-19/20120319_8.jpg'),
                gallery: gallery12Images
            },
            {
                title: 'MMCOA Visit All Malaysia Mobile Crane Owners Association (2011. 09. 10 ~ 25)',
                cover: require('@/assets/images/gallery/2011-09-10_25/20110910_6.jpg'),
                gallery: gallery13Images
            },
            {
                title: 'MMCOA Twelfth New Director Oath of Office (2011.05.15)',
                cover: require('@/assets/images/gallery/2011-05-15/20110515_8.jpg'),
                gallery: gallery14Images
            },
            {
                title: 'MMCOA 23rd Anniversary Dinner (2011.02.27)',
                cover: require('@/assets/images/gallery/2011-02-27/20110227_7.jpg'),
                gallery: gallery15Images
            },
            {
                title: 'MMCOA Chinese Tourism Delegation (2009.10.23~11.01)',
                cover: require('@/assets/images/gallery/2009-10-23_11/20091023_7.jpg'),
                gallery: gallery16Images
            },
        ]
      }
    },
    mounted() {
        window.addEventListener('keydown', this.handleKeydown)
    },
    unmounted() {
        window.removeEventListener('keydown', this.handleKeydown)
    },
    computed: {
      currentGroup() {
        return this.groups[this.currentGroupIndex];
      },
      currentImage() {
        return this.currentGroup.gallery[this.currentIndex];
      },
      hasPrev() {
        return this.currentIndex > 0;
      },
      hasNext() {
        return this.currentIndex < this.currentGroup.gallery.length - 1;
      }
    },
    methods: {
        openLightbox(groupIndex, imageIndex) {
            this.currentGroupIndex = groupIndex;
            this.currentIndex = imageIndex;
            this.visible = true;
        },
        prev() {
            if (this.hasPrev) this.currentIndex--;
        },
        next() {
            if (this.hasNext) this.currentIndex++;
        },
        handleKeydown(e) {
            if (!this.visible) return;

            if (e.key === 'Escape') {
                this.visible = false;
            } else if (e.key === 'ArrowLeft') {
                this.prev();
            } else if (e.key === 'ArrowRight') {
                this.next();
            }
        }
    }
  }
  </script>
  
  <style scoped>
  .gallery-wrapper {
    display: flex;
    gap: 50px;
    flex-wrap: wrap;
    justify-content: center;
    width: 90%;
    margin: 0 auto;
  }
  .preview-image {
    width: 400px;
    height: 300px;
    cursor: pointer;
    border-radius: 2px;
    box-shadow: 0 2px 6px rgba(0,0,0,0.2);
  }
  .lightbox-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.85);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }
  .lightbox-content {
    position: relative;
    text-align: center;
    max-width: 90%;
    max-height: 90%;
  }
  .main-image {
    max-height: 70vh;
    border-radius: 8px;
    margin-bottom: 16px;
    width: 100%;
  }
  .thumbnails {
    display: flex;
    gap: 10px;
    justify-content: center;
    overflow-x: auto;
  }
  .thumb {
    width: 60px;
    height: 40px;
    object-fit: cover;
    border-radius: 4px;
    cursor: pointer;
    opacity: 0.6;
    transition: opacity 0.2s;
  }
  .thumb.active,
  .thumb:hover {
    opacity: 1;
    border: 2px solid #fff;
  }
  .close-btn {
    position: absolute;
    top: 10px;
    right: 14px;
    font-size: 28px;
    background: transparent;
    border: none;
    color: white;
    cursor: pointer;
  }
  .nav {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    font-size: 40px;
    background: transparent;
    border: none;
    color: white;
    cursor: pointer;
  }
  .nav.left {
    left: 10px;
  }
  .nav.right {
    right: 10px;
  }

/* Scale image slightly on hover */
.group-preview {
  /* width: 33%; */
}

.preview-container {
    position: relative;
    cursor: pointer;
    /* width: 400px; */
    height: 300px;
}

.overlay {
  position: absolute;
  inset: 0;
  background: rgba(102, 102, 102, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease;
}

.overlay-text {
    position: absolute;
    top: 25px;
    left: 25px;
    font-size: 14px;
    width: 80%;
}

.preview-container:hover .overlay {
  opacity: 1;
  visibility: visible;
}
@media screen and (min-width: 968px) {
    .main-image{
        width: auto
    }
}

@media screen and (min-width: 1024px) {
    .preview-container {
        height: 300px;
    }
}

</style>
  